module.exports = __webpack_public_path__ + "static/media/pores_nose.9433cbd9.svg";